// extracted by mini-css-extract-plugin
module.exports = {"work":"Skills_work__26Hpu","bars":"Skills_bars__3lj01","skills":"Skills_skills__SMXhy","barExpand":"Skills_barExpand__1aZPL"};